import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import {makeStyles} from "@material-ui/core/styles";
import UsePeakComARU2856CControl from "./hooks/UsePeakComARU2856CControl";

const useStyles = makeStyles(() => ({
    formControl: {
        width: 166,
    }
}));

const stepSizes = [
    {"title": "10 MHz", "value": 10000},
    {"title": "1 MHz", "value": 1000},
    {"title": "100 kHz", "value": 100},
    {"title": "10 kHz", "value": 10},
    {"title": "1 kHz", "value": 1}
];

const defaultStepSize = stepSizes[0].value;

export default function PeakComARU2856CControl({pipe, handleSettingsChanged, handleSettingsApply}) {
    const classes = useStyles();

    const {
        settings,
        stepSize,
        applying,
        hasErrors,
        validationErrors,
        handleStepSizeChanged,
        handleOverrideRfInhibitStatusChanged,
        handleFrequencyChanged,
        handlePowerLevelChanged,
        handleTrimChanged,
        handleApplyClick
    } = UsePeakComARU2856CControl({
        pipe: pipe,
        defaultStepSize: defaultStepSize,
        onChanged: handleSettingsChanged,
        onApply: handleSettingsApply
    });

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"column"} alignItems={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormGroup row>
                                <FormControlLabel
                                    value="override_rf_inhibit_status"
                                    control={
                                        <Switch checked={settings.overrideRfInhibitStatus}
                                                onChange={(e) =>
                                                    handleOverrideRfInhibitStatusChanged(e.target.checked)}
                                        />
                                    }
                                    label={
                                        <Typography style={{fontSize: "0.9rem"}}>
                                            Override RF Inhibit Status
                                        </Typography>
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} container direction={"row"} justify={"center"} spacing={2}>
                        <Grid item>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="frequency-step-label">
                                    Frequency Step
                                </InputLabel>
                                <Select
                                    id="frequency-step"
                                    value={stepSize}
                                    onChange={(e) =>
                                        handleStepSizeChanged(e.target.value)}
                                >
                                    {
                                        stepSizes.map((item, index) => (
                                            <MenuItem key={`step_size_${index}`}
                                                      value={item.value}>{item.title}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                id="frequency"
                                type={"number"}
                                label="Frequency (2840000-2870000)"
                                value={settings.frequency}
                                error={validationErrors["frequency"]}
                                inputProps={{
                                    step: 1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) => handleFrequencyChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="power_level"
                                type={"number"}
                                label="Power Level (-300-300)"
                                value={settings.powerLevel}
                                error={validationErrors["power_level"]}
                                inputProps={{
                                    step: 1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) => handlePowerLevelChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="trim"
                                type={"number"}
                                label="Trim (-50-50)"
                                value={settings.trim}
                                error={validationErrors["trim"]}
                                inputProps={{
                                    step: 1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) => handleTrimChanged(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }
            bottom={
                <Button size="small"
                        variant="contained"
                        color="primary"
                        disabled={applying || hasErrors}
                        onClick={handleApplyClick}
                >
                    Apply
                </Button>
            }
        />
    );
}